<template>
  <router-view />
</template>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html,
body {
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
  height: 100%;
  line-height: 1.42857143;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #333;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.loginFormbox .van-cell-group,
.loginFormbox .van-cell {
  background: transparent !important;
  color: #fff !important;
  display: block !important;
  padding: 0 0 12px 0 !important;
}
.loginFormbox .van-field__label {
  color: #fff !important;
}
.loginFormbox .van-field__value {
  margin-top: 0.3rem;
}
.loginFormbox .bor .van-field__value .van-field__body {
  padding: 0.3rem 0.16rem;
  border: 1px solid #fff !important;
}
.loginFormbox .van-field__control {
  color: #fff !important;
}
@media screen and (min-width: 768px) {
  body {
    height: 100%;
  }
  #app {
    box-shadow: 0px 0px 10px #ccc;
    position: relative;
  }
}
</style>
